export default __webpack_public_path__ + "static/media/megha.7ef1d644.JPG";